module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "district"
  }, [_c('span', {
    staticClass: "district-title"
  }, [_vm._v("您可能感兴趣的小区")]), _vm._v(" "), _c('div', {
    staticClass: "district-routes"
  }, _vm._l((_vm.routes), function(item, index) {
    return _c('router-link', {
      key: index,
      staticClass: "router-link",
      attrs: {
        "to": {
          name: 'charts',
          params: {
            name: item.name,
            distance: item.distance,
            type: 0,
            from: 'list'
          }
        }
      }
    }, [_vm._v(_vm._s(item.name))])
  }))])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5ca84fa5"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ditribution/NIDistrict.vue
// module id = 494
// module chunks = 1